import { ShipmentStatus } from "@/typedefs/shipment";
import { QuoteStatus } from "@/typedefs/vehicle";
import { getDealerQuickQuotesCount } from "@/services/pricingService";
import { getShipmentCount, getDealerDashboardMap } from "@/services/shipments";

const Model = {
  namespace: "dealerDashboard",
  state: {
    data: {
      quotes: {
        pendingQuotesCount: 0,
        completedQuotesCount: 0,
      },
      shipments: {
        pendingQuotesShipmentsCount: 0,
        completedQuotesShipmentsCount: 0,
        completedQuotesShipmentsWithExpiredCount: 0,
        postedShipmentsCount: 0,
        assignedShipmentsCount: 0,
        deliveredShipmentsCount: 0,
      },
      quickQuotes: {
        dealerQuickQuotesCount: 0,
      },
    },
  },
  effects: {
    *fetchDealerQuickQuotesCount(_, { call, put }) {
      const dealerQuickQuotesCount = yield call(getDealerQuickQuotesCount);

      yield put({
        type: "updateQuickQuotesProperty",
        payload: {
          dealerQuickQuotesCount,
        },
      });
    },
    *fetchPendingQuotesShipmentsCount(_, { call, put }) {
      const pendingQuotesShipmentsCount = yield call(getShipmentCount, {
        status: ShipmentStatus.Pending,
      });

      yield put({
        type: "updateShipmentsProperty",
        payload: {
          pendingQuotesShipmentsCount,
        },
      });
    },
    *fetchCompletedQuotesShipmentsCount(_, { call, put }) {
      const completedQuotesShipmentsCount = yield call(getShipmentCount, {
        status: ShipmentStatus.Completed,
        quoteStatus: QuoteStatus.Completed,
      });

      yield put({
        type: "updateShipmentsProperty",
        payload: {
          completedQuotesShipmentsCount,
        },
      });
    },
    *fetchCompletedQuotesWithExpiredShipmentsCount(_, { call, put }) {
      const completedQuotesWithExpiredShipmentsCount = yield call(getShipmentCount, {
        status: ShipmentStatus.Completed,
        quoteStatus: QuoteStatus.Expired,
      });

      yield put({
        type: "updateShipmentsProperty",
        payload: {
          completedQuotesShipmentsWithExpiredCount: completedQuotesWithExpiredShipmentsCount,
        },
      });
    },
    *fetchPostedShipmentsCount(_, { call, put }) {
      const postedShipmentsCount = yield call(getShipmentCount, {
        status: ShipmentStatus.Posted,
      });

      yield put({
        type: "updateShipmentsProperty",
        payload: {
          postedShipmentsCount,
        },
      });
    },
    *fetchAssignedShipmentsCount(_, { call, put }) {
      const assignedShipmentsCount = yield call(getShipmentCount, {
        status: ShipmentStatus.Assigned,
      });

      yield put({
        type: "updateShipmentsProperty",
        payload: {
          assignedShipmentsCount,
        },
      });
    },
    *fetchDeliveredShipmentsCount(_, { call, put }) {
      const deliveredShipmentsCount = yield call(getShipmentCount, {
        status: ShipmentStatus.Delivered,
      });

      yield put({
        type: "updateShipmentsProperty",
        payload: {
          deliveredShipmentsCount,
        },
      });
    },
    *fetchMap(_, { call, put }) {
      const shipments = yield call(getDealerDashboardMap);

      yield put({
        type: "updateShipmentsProperty",
        payload: {
          mapShipments: shipments,
        },
      });
    },
  },
  reducers: {
    updateShipmentsProperty(state, { payload }) {
      const newState = {
        ...state,
        data: {
          ...state.data,
          shipments: {
            ...state.data?.shipments,
            ...payload,
          },
        },
      };

      return newState;
    },
    updateQuickQuotesProperty(state, { payload }) {
      return {
        ...state,
        data: {
          ...state.data,
          quickQuotes: {
            ...state.data?.quickQuotes,
            ...payload,
          },
        },
      };
    },
  },
};

export default Model;
